import { render, staticRenderFns } from "./GoodsListItem.vue?vue&type=template&id=109bd5cd&scoped=true&"
import script from "./GoodsListItem.vue?vue&type=script&lang=js&"
export * from "./GoodsListItem.vue?vue&type=script&lang=js&"
import style0 from "./GoodsListItem.vue?vue&type=style&index=0&id=109bd5cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109bd5cd",
  null
  
)

export default component.exports